import type React from 'react';
import { useCallback, useState } from 'react';

import { faPalette } from '@fortawesome/free-solid-svg-icons';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Popover, View } from '@zinc/ui';
import Palette from '../colour-palette';

interface ColourPickerProps {
  value?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  dataTestId?: string;
}

const ColourPicker: React.FC<ColourPickerProps> = ({
  value = 'var(--rs-color-background-primary)',
  readOnly,
  onChange,
  dataTestId
}) => {
  const [open, setOpen] = useState(false);

  const handleChange = useCallback(
    (color: string) => {
      setOpen(false);
      onChange?.(color);
    },
    [onChange]
  );

  return (
    <div data-testid={dataTestId}>
      <Popover active={open} onOpen={() => setOpen(true)}>
        <Popover.Trigger>
          {(attributes) =>
            !readOnly && (
              <Button
                variant="outline"
                icon={
                  <FontAwesomeIcon
                    style={{ color: value || 'var(--rs-color-background-primary)' }}
                    className="w-[30px]"
                    icon={faPalette}
                  />
                }
                endIcon={<FontAwesomeIcon className="ml-2 mr-2" icon={faAngleDown} />}
                {...attributes}
              ></Button>
            )
          }
        </Popover.Trigger>
        <Popover.Content attributes={{ role: 'slider' }}>
          <Palette value={value} onChange={handleChange} />
        </Popover.Content>
      </Popover>
    </div>
  );
};

export default ColourPicker;
